import {h, render} from 'preact';
import $ from '@modules/jquery-import';
import {MediumDevice} from '@components/common/MediaQueries';
import MiniCart from '@containers/MiniCart';
import MiniCartBadge from '@containers/MiniCartBadge';
import MiniCartSummary from '@containers/MiniCartSummary';
import Provider from 'preact-context-provider';
import {client} from '@core/GraphQLProvider';
import User from '@modules/User';

const App = {
    init ( isEnabled = false ) {

        const isLogged = User.isLogged();

        if ( isEnabled ) {
            $( document ).on( 'click', '[data-action="toggle-cart"]', e => {
                e.preventDefault();
                $( 'html' ).toggleClass( 'js-off-canvas--open' );
            } );

            const rootEl = document.getElementById( 'content-pane' );
            if ( rootEl ) {
                render(
                    <MediumDevice
                        component="div"
                        id="cart-panel"
                        className="off-canvas-panel off-canvas-panel--cart">
                        <Provider client={client}>
                            <MiniCart isLogged={isLogged}/>
                        </Provider>
                    </MediumDevice>,
                    rootEl );
            }

        }
        const cartNav = document.getElementById( 'nav-item--cart' );
        if ( cartNav ) {
            render(
                <Provider client={client} miniCartEnabled={isEnabled}>
                    <MiniCartSummary/>
                </Provider>,
                null, cartNav )
        }

        const cartBadgeMobile = document.getElementById( 'nav-bar-cart-badge--mobile' );
        if ( cartBadgeMobile ) {
            render(
                <Provider client={client}>
                    <MiniCartBadge/>
                </Provider>,
                null, cartBadgeMobile )
        }
    }
};

export default App;
